/**
 * Auth feature — AR copy (Stitch rebuild, DEC-051).
 * Natural Modern Standard Arabic, logical order. Keys mirror auth.en.ts.
 */

export const authAr = {
  'auth.login.title': 'مرحبًا بعودتك',
  'auth.login.subtitle': 'سجّل الدخول إلى مساحة ذكاء ووركرايز الخاصة بك.',
  'auth.register.title': 'أنشئ حسابك',
  'auth.register.subtitle': 'ابدأ بتحويل إشارات مسارك إلى اتجاه واضح.',

  'auth.mode.login': 'تسجيل الدخول',
  'auth.mode.register': 'إنشاء حساب',

  'auth.field.email.label': 'البريد الإلكتروني',
  'auth.field.email.placeholder': 'you@example.com',
  'auth.field.firstName.label': 'الاسم الأول',
  'auth.field.firstName.placeholder': 'Jane',
  'auth.field.lastName.label': 'اسم العائلة',
  'auth.field.lastName.placeholder': 'Doe',
  'auth.field.password.label': 'كلمة المرور',
  'auth.field.password.placeholder': '••••••••',
  'auth.field.password.forgot': 'نسيتها؟',
  'auth.field.confirm.label': 'تأكيد كلمة المرور',

  'auth.submit.login': 'تسجيل الدخول',
  'auth.submit.register': 'إنشاء حساب',
  'auth.submit.loading': 'جارٍ العمل',
  'auth.logout': 'تسجيل الخروج',
  'auth.error.passwordMismatch': 'كلمتا المرور غير متطابقتين.',
  'auth.callback.loading': 'جارٍ إكمال تسجيل الدخول…',

  'auth.social.divider': 'أو تابِع بالبريد الإلكتروني',
  'auth.social.google': 'المتابعة عبر Google',
  'auth.social.comingSoon': 'تسجيل الدخول عبر مزوّدي الخدمة قريبًا',
  'auth.social.disabled.title': 'تسجيل الدخول عبر Google غير مُفعّل',
  'auth.social.disabled.body':
    'لم يتم إعداد تسجيل الدخول عبر Google بعد. استخدم البريد الإلكتروني أو اطلب الوصول المبكر.',

  'auth.terms.lead': 'بالمتابعة، فإنك توافق على',
  'auth.terms.terms': 'الشروط',
  'auth.terms.and': 'و',
  'auth.terms.privacy': 'سياسة الخصوصية',

  'auth.switch.toRegister.prompt': 'جديد على ووركرايز؟',
  'auth.switch.toRegister.action': 'أنشئ حسابًا',
  'auth.switch.toLogin.prompt': 'لديك حساب بالفعل؟',
  'auth.switch.toLogin.action': 'تسجيل الدخول',

  'auth.preview.note': 'الحسابات متصلة بواجهة ووركرايز الحية.',

  'auth.value.badge': 'مبنيّ بالذكاء الاصطناعي',
  'auth.value.headline.lead': 'حوّل إشاراتك إلى',
  'auth.value.headline.accent': 'حركة صاعدة.',
  'auth.value.subtitle':
    'يقرأ ووركرايز مشهد المواهب ويرسم طريقك نحو الإتقان — بالعربية والإنجليزية.',
  'auth.value.benefit1.title': 'افهم نقاط قوّتك',
  'auth.value.benefit1.body':
    'يُظهر ووركرايز المهارات والقدرات الكامنة التي لم تكن تعرف أنك تملكها.',
  'auth.value.benefit2.title': 'اكتشف فجوات نموّك',
  'auth.value.benefit2.body':
    'احصل على خطوات تالية دقيقة ومرتّبة لتتعلّم ما يبقيك متقدّمًا.',
  'auth.value.trust': 'خاص بالتصميم · يبدأ من الشرق الأوسط · ثنائي اللغة',
} as const;

export type AuthAr = typeof authAr;
